import { ComponentProps, ComponentPropsWithRef } from "react";
import styled, { css } from "styled-components";
import {
  primary01,
  primary03,
  shade0,
  shade500,
  shade700,
  shade800,
  shade950,
} from "../../styles/tokens";

// TEXT

// STYLES
export const Container = styled.div<ContainerProps>`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: ${shade950};
  color: ${({ $type }) => ($type === "secondary" ? shade0 : primary01)};
  border: 1px solid ${shade700};
  border-radius: ${({ $type }) => ($type === "selector" ? "50%" : "0")};
  overflow: hidden;
  cursor: pointer;

  ${({ $disabled, $type }) =>
    $disabled
      ? css`
          cursor: not-allowed;
          color: ${shade700};
          border-color: ${shade800};
          background-color: ${shade700};
        `
      : css`
          &:hover {
            border-color: ${shade500};
            color: ${$type === "secondary" ? shade0 : primary03};
          }

          &:focus-visible {
            box-shadow: 0 0 0 2px ${shade0};
            cursor: not-allowed;
          }
        `};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"div"> {
  variant?: "unchecked" | "checked" | "indeterminate" | "excluded";
  type?: "primary" | "secondary" | "selector";
  disabled?: boolean;
}

type ContainerProps = ComponentProps<"div"> & {
  $type: Props["type"];
  $disabled: Props["disabled"];
};

export type IconProps = ComponentPropsWithRef<"svg"> & Omit<Props, "variant">;

// CONSTANTS

// FUNCTIONS

// ASSETS
